/* eslint-disable */

// This is a generated file and SHOULD NOT BE EDITED MANUALLY!!
// Contents are generated as part of grunt build
// Source of truth is lib/cdo/shared_constants.rb and files in lib/cdo/shared_constants/

export const Courses = [
  "CS Principles",
  "CS Discoveries",
  "Computer Science A",
  "Facilitator",
  "Admin/Counselor Workshop",
  "Build Your Own Workshop",
  "AI Foundations",
  "CS Fundamentals",
  "Exploring Computer Science",
  "CS in Algebra",
  "CS in Science",
  "Counselor",
  "Admin"
];

export const ActiveCourses = [
  "CS Principles",
  "CS Discoveries",
  "Computer Science A",
  "Facilitator",
  "Admin/Counselor Workshop",
  "Build Your Own Workshop",
  "AI Foundations"
];

export const ArchivedCourses = [
  "CS Fundamentals",
  "Exploring Computer Science",
  "CS in Algebra",
  "CS in Science",
  "Counselor",
  "Admin"
];

export const CourseKeyMap = {
  "CS Fundamentals": "csf",
  "CS Discoveries": "csd",
  "CS Principles": "csp",
  "Computer Science A": "csa"
};

export const SubjectNames = {
  "SUBJECT_CSF_101": "Intro",
  "SUBJECT_CSF_201": "Deep Dive",
  "SUBJECT_CSF_DISTRICT": "District",
  "SUBJECT_FIT": "Code.org Facilitator Weekend",
  "SUBJECT_SUMMER_WORKSHOP": "5-day Summer",
  "SUBJECT_VIRTUAL_KICKOFF": "Virtual Workshop Kickoff",
  "SUBJECT_CSP_FOR_RETURNING_TEACHERS": "Workshop for Returning Teachers",
  "SUBJECT_ADMIN_COUNSELOR_WELCOME": "Welcome",
  "SUBJECT_ADMIN_COUNSELOR_SLP_INTRO": "SLP Intro",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL1": "SLP Quarterly Call 1",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL2": "SLP Quarterly Call 2",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL3": "SLP Quarterly Call 3",
  "SUBJECT_ADMIN_COUNSELOR_SLP_CALL4": "SLP Quarterly Call 4",
  "SUBJECT_CUSTOM_WORKSHOP": "Custom Workshop"
};

export const Subjects = {
  "Exploring Computer Science": [
    "Phase 2 in-person",
    "Unit 3 - HTML",
    "Unit 4 - Scratch",
    "Unit 5 - Data",
    "Unit 6 - Robotics",
    "Phase 4: Summer wrap-up"
  ],
  "CS in Algebra": [
    "Phase 2 in-person",
    "Phase 3: Academic Year Development"
  ],
  "CS in Science": [
    "Phase 2: Blended Summer Study",
    "Phase 3 - Semester 1",
    "Phase 3 - Semester 2"
  ],
  "CS Principles": [
    "5-day Summer",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4"
  ],
  "Computer Science A": [
    "5-day Summer",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4"
  ],
  "CS Discoveries": [
    "5-day Summer",
    "Academic Year Workshop 1",
    "Academic Year Workshop 2",
    "Academic Year Workshop 3",
    "Academic Year Workshop 4",
    "Academic Year Workshop 1 + 2",
    "Academic Year Workshop 3 + 4"
  ],
  "CS Fundamentals": [
    "Intro",
    "Deep Dive",
    "District"
  ],
  "Admin/Counselor Workshop": [
    "Welcome",
    "SLP Intro",
    "SLP Quarterly Call 1",
    "SLP Quarterly Call 2",
    "SLP Quarterly Call 3",
    "SLP Quarterly Call 4"
  ]
};

export const HideFeeInformationSubjects = [
  "District"
];

export const HideOnWorkshopMapSubjects = [
  "District"
];

export const HideFundedSubjects = [
  "District"
];

export const MustSuppressEmailSubjects = [
  "Virtual Workshop Kickoff",
  "Code.org TeacherCon",
  "Code.org Facilitator Weekend",
  "Workshop for Returning Teachers",
  "Code.org TeacherCon",
  "Code.org Facilitator Weekend",
  "Code.org Facilitator Weekend",
  "Code.org Facilitator Weekend",
  "Capstone",
  "Welcome",
  "SLP Intro",
  "SLP Quarterly Call 1",
  "SLP Quarterly Call 2",
  "SLP Quarterly Call 3",
  "SLP Quarterly Call 4"
];

export const AcademicYearWorkshopSubjects = [
  "Virtual Workshop Kickoff",
  "Academic Year Workshop 1",
  "Academic Year Workshop 2",
  "Academic Year Workshop 3",
  "Academic Year Workshop 4",
  "Academic Year Workshop 1 + 2",
  "Academic Year Workshop 3 + 4"
];

export const LegacySubjects = {
  "CS Principles": [
    "Workshop 1: Unit 3",
    "Workshop 2: Unit 4 and Explore Task",
    "Workshop 3: Unit 5 and Create Task",
    "Workshop 4: Unit 5 and Multiple Choice Exam",
    "2-day, Workshops 1+2: Units 3-4 and Explore Task",
    "2-day, Workshops 3+4: Unit 5, Create Task, and Multiple Choice Exam",
    "1-day Academic Year, Units 1 and 2",
    "1-day Academic Year, Unit 3",
    "1-day Academic Year, Unit 4 + Explore Prep",
    "1-day Academic Year, Unit 5 + Create Prep",
    "2-day Academic Year, Units 1 to 3",
    "2-day Academic Year, Units 4 and 5 + AP Prep",
    "Virtual Workshop 1",
    "Virtual Workshop 2",
    "Virtual Workshop 3",
    "Virtual Workshop 4",
    "Virtual Workshop 5",
    "Virtual Workshop 6",
    "Virtual Workshop 7",
    "Virtual Workshop 8",
    "Code.org TeacherCon",
    "Code.org Facilitator Weekend",
    "Workshop for Returning Teachers",
    "Virtual Workshop Kickoff"
  ],
  "CS Discoveries": [
    "Workshop 1: Unit 3",
    "Workshop 2: Unit 4",
    "Workshop 3: Unit 5",
    "Workshop 4: Unit 6",
    "2-day, Workshops 1+2: Units 3 and 4",
    "2-day, Workshops 3+4: Units 5 and 6",
    "1-day Academic Year, Units 1 and 2",
    "1-day Academic Year, Unit 3",
    "1-day Academic Year, Units 4 and 5",
    "1-day Academic Year, Unit 6",
    "2-day Academic Year, Units 1 to 3",
    "2-day Academic Year, Units 4 to 6",
    "Virtual Workshop 1",
    "Virtual Workshop 2",
    "Virtual Workshop 3",
    "Virtual Workshop 4",
    "Virtual Workshop 5",
    "Virtual Workshop 6",
    "Virtual Workshop 7",
    "Virtual Workshop 8",
    "Custom Workshop",
    "Code.org TeacherCon",
    "Code.org Facilitator Weekend",
    "Virtual Workshop Kickoff"
  ],
  "CS Fundamentals": [
    "Code.org Facilitator Weekend"
  ],
  "Computer Science A": [
    "Code.org Facilitator Weekend",
    "Capstone",
    "Virtual Workshop Kickoff"
  ]
};

export const States = [
  "Not Started",
  "In Progress",
  "Ended"
];

export const WorkshopApplicationStates = {
  "now_closed": "now_closed",
  "currently_open": "currently_open",
  "opening_at": "opening_at",
  "opening_sometime": "opening_sometime"
};

export const WorkshopSearchErrors = {
  "no_partner": "no_partner",
  "no_state": "no_state",
  "unknown": "unknown"
};

export const ActiveCourseWorkshops = {
  "CSD": "CS Discoveries",
  "CSP": "CS Principles",
  "CSA": "Computer Science A"
};

export const ActiveCoursesWithSurveys = [
  "CS Discoveries",
  "CS Principles",
  "Computer Science A",
  "CS Fundamentals"
];

export const WorkshopTypes = {
  "teachercon": "Code.org TeacherCon",
  "local_summer": "5-day Summer",
  "both": "both"
};

export const NotFundedSubjects = [
  "Welcome",
  "SLP Intro",
  "SLP Quarterly Call 1",
  "SLP Quarterly Call 2",
  "SLP Quarterly Call 3",
  "SLP Quarterly Call 4"
];

export const CsdCustomWorkshopModules = [
  "Computer Science Basics for K-5 Teachers",
  "CS Fundamentals Maker with micro:bit",
  "Teaching Artificial Intelligence and Machine Learning",
  "Teaching Creating Apps with Devices (Circuit Playground)",
  "Teaching Creating Apps with Devices (micro:bit)",
  "Teaching CS Connections",
  "Teaching Data and Society",
  "Teaching Design Process",
  "Teaching Interactive Animations and Games",
  "Teaching Problem Solving and Computing",
  "Teaching Web Development"
];

export const ParticipantGroupTypes = [
  "District",
  "Multi-district",
  "Regional",
  "National",
  "Facilitator",
  "Train the trainer"
];

export const WorkshopGradeLevels = [
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12"
];

export const PdSessionFormats = [
  {
    "value": "in_person",
    "label": "In-Person",
    "enum_value": 0
  },
  {
    "value": "virtual",
    "label": "Virtual",
    "enum_value": 1
  }
];

export const WorkshopFormats = {
  "in_person": "In-Person",
  "hybrid": "Hybrid",
  "virtual": "Virtual"
};

export const WorkshopCourseConfigs = [
  {
    "slug": "build_your_own_workshop",
    "label": "Build Your Own Workshop",
    "icon": "plus-square",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      },
      "course_offerings": {
        "required": true,
        "stateKey": "courseOfferings",
        "label": "Select workshop topic(s)"
      },
      "participant_group_type": {
        "required": true,
        "stateKey": "participantGroupType",
        "label": "Cohort type",
        "options": [
          {
            "value": "District",
            "label": "District"
          },
          {
            "value": "Multi-district",
            "label": "Multi-district"
          },
          {
            "value": "Regional",
            "label": "Regional"
          },
          {
            "value": "National",
            "label": "National"
          },
          {
            "value": "Facilitator",
            "label": "Facilitator"
          },
          {
            "value": "Train the trainer",
            "label": "Train the trainer"
          }
        ]
      }
    }
  },
  {
    "slug": "cs_principles",
    "label": "CS Principles",
    "icon": "book",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      },
      "subject": {
        "required": true,
        "stateKey": "subject",
        "label": "Subject",
        "options": [
          {
            "value": "5-day Summer",
            "label": "5-day Summer"
          },
          {
            "value": "Academic Year Workshop 1",
            "label": "Academic Year Workshop 1"
          },
          {
            "value": "Academic Year Workshop 2",
            "label": "Academic Year Workshop 2"
          },
          {
            "value": "Academic Year Workshop 3",
            "label": "Academic Year Workshop 3"
          },
          {
            "value": "Academic Year Workshop 4",
            "label": "Academic Year Workshop 4"
          },
          {
            "value": "Academic Year Workshop 1 + 2",
            "label": "Academic Year Workshop 1 + 2"
          },
          {
            "value": "Academic Year Workshop 3 + 4",
            "label": "Academic Year Workshop 3 + 4"
          }
        ]
      }
    }
  },
  {
    "slug": "cs_discoveries",
    "label": "CS Discoveries",
    "icon": "book",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      },
      "subject": {
        "required": true,
        "stateKey": "subject",
        "label": "Subject",
        "options": [
          {
            "value": "5-day Summer",
            "label": "5-day Summer"
          },
          {
            "value": "Academic Year Workshop 1",
            "label": "Academic Year Workshop 1"
          },
          {
            "value": "Academic Year Workshop 2",
            "label": "Academic Year Workshop 2"
          },
          {
            "value": "Academic Year Workshop 3",
            "label": "Academic Year Workshop 3"
          },
          {
            "value": "Academic Year Workshop 4",
            "label": "Academic Year Workshop 4"
          },
          {
            "value": "Academic Year Workshop 1 + 2",
            "label": "Academic Year Workshop 1 + 2"
          },
          {
            "value": "Academic Year Workshop 3 + 4",
            "label": "Academic Year Workshop 3 + 4"
          }
        ]
      }
    }
  },
  {
    "slug": "computer_science_a",
    "label": "Computer Science A",
    "icon": "book",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      },
      "subject": {
        "required": true,
        "stateKey": "subject",
        "label": "Subject",
        "options": [
          {
            "value": "5-day Summer",
            "label": "5-day Summer"
          },
          {
            "value": "Academic Year Workshop 1",
            "label": "Academic Year Workshop 1"
          },
          {
            "value": "Academic Year Workshop 2",
            "label": "Academic Year Workshop 2"
          },
          {
            "value": "Academic Year Workshop 3",
            "label": "Academic Year Workshop 3"
          },
          {
            "value": "Academic Year Workshop 4",
            "label": "Academic Year Workshop 4"
          },
          {
            "value": "Academic Year Workshop 1 + 2",
            "label": "Academic Year Workshop 1 + 2"
          },
          {
            "value": "Academic Year Workshop 3 + 4",
            "label": "Academic Year Workshop 3 + 4"
          }
        ]
      }
    }
  },
  {
    "slug": "admin_counselor_workshop",
    "label": "Admin/Counselor Workshop",
    "icon": "users",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      },
      "subject": {
        "required": true,
        "stateKey": "subject",
        "label": "Subject",
        "options": [
          {
            "value": "Welcome",
            "label": "Welcome"
          },
          {
            "value": "SLP Intro",
            "label": "SLP Intro"
          },
          {
            "value": "SLP Quarterly Call 1",
            "label": "SLP Quarterly Call 1"
          },
          {
            "value": "SLP Quarterly Call 2",
            "label": "SLP Quarterly Call 2"
          },
          {
            "value": "SLP Quarterly Call 3",
            "label": "SLP Quarterly Call 3"
          },
          {
            "value": "SLP Quarterly Call 4",
            "label": "SLP Quarterly Call 4"
          }
        ]
      }
    }
  },
  {
    "slug": "facilitator",
    "label": "Facilitator",
    "icon": "users",
    "session_fields": {
      "date": {
        "required": true,
        "stateKey": "date",
        "label": "Date"
      },
      "start": {
        "required": true,
        "stateKey": "start",
        "label": "Start time"
      },
      "end": {
        "required": true,
        "stateKey": "end",
        "label": "End time"
      },
      "session_format": {
        "required": true,
        "stateKey": "format",
        "label": "Format",
        "options": [
          {
            "value": "in_person",
            "label": "In-Person",
            "enum_value": 0
          },
          {
            "value": "virtual",
            "label": "Virtual",
            "enum_value": 1
          }
        ]
      },
      "location_name": {
        "required": false,
        "stateKey": "locationName",
        "label": "Location name"
      },
      "location_address": {
        "required": false,
        "stateKey": "locationAddress",
        "label": "Location address"
      },
      "meeting_link": {
        "required": false,
        "stateKey": "meetingLink",
        "label": "Meeting link"
      }
    },
    "fields": {
      "name": {
        "required": true,
        "stateKey": "name",
        "label": "Workshop name",
        "helperMessage": "Name of the workshop for public and internal use."
      },
      "capacity": {
        "required": true,
        "stateKey": "capacity",
        "label": "Capacity",
        "helperMessage": "Maximum number of attendees allowed."
      },
      "grades": {
        "required": true,
        "stateKey": "grades",
        "label": "Grade levels",
        "helperMessage": "Select applicable grade levels for this workshop."
      },
      "description": {
        "required": true,
        "stateKey": "description",
        "label": "Workshop description"
      },
      "notes": {
        "required": false,
        "stateKey": "notes",
        "label": "Attendee notes",
        "helperMessage": "Notes for logistics like food, parking, or other event details."
      },
      "suppress_email": {
        "required": false,
        "stateKey": "suppressEmail",
        "label": "3 and 10-days prior to start date"
      },
      "regional_partner_id": {
        "required": false,
        "stateKey": "regionalPartnerId",
        "label": "Regional partner"
      },
      "organizer_id": {
        "required": false,
        "stateKey": "organizerId",
        "label": "Organizer"
      },
      "facilitators": {
        "required": false,
        "stateKey": "facilitators",
        "label": "Select facilitator(s)"
      },
      "fee": {
        "required": false,
        "stateKey": "fee",
        "label": "Workshop cost",
        "helperMessage": "You can leave this field blank if the workshop is free."
      },
      "prereq": {
        "required": false,
        "stateKey": "prereq",
        "label": "Experience needed",
        "helperMessage": "Indicate if this workshop requires previous experience."
      },
      "hidden": {
        "required": false,
        "stateKey": "hidden",
        "label": "Catalog visibility",
        "helperMessage": "Hide this workshop from the public workshop catalog."
      },
      "registration_link": {
        "required": false,
        "stateKey": "registrationLink",
        "label": "Custom registration link",
        "helperMessage": "You can provide a custom URL for registration. Participants must still enroll in our system later for attendance and surveys. Leave blank to use the default process."
      },
      "time_zone": {
        "required": false,
        "stateKey": "timeZone",
        "label": "Workshop time(s) will be set to timezone:"
      }
    }
  }
];

export const CourseBuildYourOwn = 'Build Your Own Workshop';
